import cityFeatureFlags from "./cityFeatureFlags.component";

const cityFeatureFlagsModule = angular
  .module("app.components.cityFeatureFlags", [])
  .component("cityFeatureFlags", cityFeatureFlags);

export default cityFeatureFlagsModule;



// WEBPACK FOOTER //
// ./src/components/cityFeatureFlags/cityFeatureFlags.module.js